import * as $ from "jquery";

export function initAutocomplete() {

    const AutocompleteSize = 5;

    let autocompleteContainers = document.querySelectorAll('[data-search-autocomplete-container]');
    for (let i = 0; i < autocompleteContainers.length; i++) {
        initAutocomplete(autocompleteContainers[i]);
    }

    function initAutocomplete(container) {
        let searchInput = container.querySelector('[data-searchterm]');
        let autocomplete = container.querySelector('[data-autocompletecontainer]');
        let autocompleteList = autocomplete.querySelector('ul');

        document.addEventListener("click", function (e) {
            // if the target of the click isn't the container nor a descendant of the container
            if (!container.contains(e.target)) {
                inactivateAndEmpty();
            }
        })

        searchInput.addEventListener("keyup", function () {

            if (!searchInput.value) {
                inactivateAndEmpty();
            }

            var lastResults = $(this).data('results') || "";
            let isActive = '';
            let searchTerm = searchInput.value;

            if (searchTerm.length > 0) {
                isActive = 'active';
            }

            let autocompleteUrl = `/api/autocomplete/fetch/${searchTerm}/${AutocompleteSize}`;

            $.getJSON(autocompleteUrl, function (data) {
                if (!data.hits || data.hits.length < 1) {
                    inactivateAndEmpty();
                    return;
                }

                if (data.hits != lastResults) {
                    $(autocompleteList).empty();
                    $(searchInput).data('results', data.hits);
                    $.each(data.hits, function (index, value) {
                        $(autocomplete).addClass(isActive).find('ul').append('<li><a class="autocomplete-item" href="' + window.bootstrap.searchPageUrl + '?q=' + value.Query.replace(/ /g, '%20').replace(/&/g, '%26').replace(/\+/g, '%20') + '&p=products">' + value.Query.replace(/\+/g, ' ') + '</a></li>');
                    });
                }

            });
        })

        function inactivateAndEmpty() {
            $(autocomplete).removeClass('active');
            $(autocompleteList).empty();
        }

        document.addEventListener("keydown", function (e) {
            if (container.contains(document.activeElement) && ($(document.activeElement).hasClass("autocomplete-item") || $(document.activeElement).hasClass("autocomplete-box")) && e.keyCode == 40) {
                e.preventDefault();
                e.stopPropagation();
                var focusLi = $(autocomplete.querySelector('.autocomplete-item:focus'));
                if (focusLi.length == 0) {
                    let item = autocomplete.querySelector('.autocomplete-item');
                    item.focus();
                }
                else {
                    focusLi.parent().next().find('a').focus();
                }
                return false;
            }
        })

        document.addEventListener("keydown", function (e) {
            if (container.contains(document.activeElement) && ($(document.activeElement).hasClass("autocomplete-item") || $(document.activeElement).hasClass("autocomplete-box")) && e.keyCode == 38) {
                e.preventDefault();
                e.stopPropagation();
                var focusLi = $(document.activeElement);
                var toFocus = focusLi.parent().prev().find('a');

                if (toFocus.length == 0) {
                    searchInput.focus();
                }
                else {
                    toFocus.focus();
                }
                return false;
            }
        })

        searchInput.addEventListener("keypress", function (e) {
            if (e.keyCode === 13) {
                e.preventDefault();
                e.stopPropagation();
                submitSearch();
            }
        })

        let searchButton = container.querySelector('[data-searchbutton]');
        if (searchButton) {
            searchButton.addEventListener("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                submitSearch();
            })
        }

        function submitSearch() {
            let term = searchInput.value;
            term = term.replace(/#/g, '').replace(/&/g, '%26').replace(/\"/g, '%5C%22').replace(/\'/g, "%5C%27").replace(/\\/g, "%2F");
            if (!term) {
                $(searchInput).prop('placeholder', 'Please enter a search term first');
                return;
            }

            let search = window.bootstrap.searchPageUrl + '?q=' + term + '&p=products';
            window.location.assign(search);
        }
    }
}